import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/acadebility-logo.png";

/* ─── Small inline icons (kept dependency-free) ────────────────────────────── */
const IconSend = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
const IconArrowUp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);
const IconMail = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    // TODO: wire this up to the real newsletter API endpoint
    setSubscribed(true);
    setEmail("");
    setTimeout(() => setSubscribed(false), 4000);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const year = new Date().getFullYear();

  return (
    <footer className="acad-footer">

      {/* ── Newsletter strip ── */}
      <div className="acad-footer-newsletter">
        <div className="acad-footer-inner acad-newsletter-inner">
          <div className="acad-newsletter-copy">
            <h3>Get exam-ready, every week</h3>
            <p>Fresh mock tests, MCQ practice sets, and interview prep tips — straight to your inbox.</p>
          </div>
          <form className="acad-newsletter-form" onSubmit={handleSubscribe}>
            <div className="acad-newsletter-input-wrap">
              <IconMail />
              <input
                type="email"
                required
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email address"
              />
            </div>
            <button type="submit" className="acad-newsletter-btn">
              {subscribed ? "Subscribed ✓" : (
                <>
                  Subscribe <IconSend />
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="acad-footer-top">
        <div className="acad-footer-inner">

          {/* Brand column */}
          <div className="acad-footer-brand">
            <Link to="/" className="acad-footer-logo">
              <img
                src={logo}
                alt="Acadebility Logo"
                width={38}
                height={38}
                className="acad-logo-icon"
              />
              <span>acade<span className="acad-logo-accent">bility</span></span>
            </Link>
            <p className="acad-footer-tagline">
              Acadebility is an online learning platform dedicated to helping students achieve their academic and career goals through high-quality mock tests, practice questions, live learning, interview preparation, and expert educational content.
            </p>

            <div className="acad-footer-contact-mini">
              <a href="mailto:acadebility@gmail.com" className="acad-contact-mini-item">
                <IconMail /> acadebility@gmail.com
              </a>
            </div>

            <div className="acad-footer-socials">
              <a href="https://www.facebook.com/profile.php?id=61591769297796" target="_blank" rel="noreferrer" aria-label="Facebook" className="acad-social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a href="https://www.instagram.com/acadebility/" target="_blank" rel="noreferrer" aria-label="Instagram" className="acad-social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
              </a>
              <a href="https://www.linkedin.com/in/acadebility-learning-7573b524a/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="acad-social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter/X" className="acad-social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="acad-social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 1.96A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1C5.12 19.56 12 19.56 12 19.56s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.95 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.4z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="white"/></svg>
              </a>
            </div>
          </div>

          {/* Learn column */}
          <div className="acad-footer-col">
            <h4 className="acad-footer-col-title">Learn</h4>
            <ul className="acad-footer-links">
              <li><Link to="/online-test-series">Test Series</Link></li>
              <li><Link to="/blogs/all-blogs/mcqs">MCQ Practice</Link></li>
              <li><Link to="/blogs/all-blogs/posts">Blog Posts</Link></li>
              <li><Link to="/blogs/all-blogs/technical_posts">Technical Blogs</Link></li>
              <li><Link to="/blogs/all-blogs/interview_questions">Interview Questions</Link></li>
            </ul>
          </div>

          {/* Company column */}
          <div className="acad-footer-col">
            <h4 className="acad-footer-col-title">Company</h4>
            <ul className="acad-footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/site-maps">Site Map</Link></li>
            </ul>
          </div>

          {/* Legal column */}
          <div className="acad-footer-col">
            <h4 className="acad-footer-col-title">Legal</h4>
            <ul className="acad-footer-links">
              <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
            </ul>
          </div>

        </div>
      </div>

      <div className="acad-footer-bottom">
        <div className="acad-footer-inner acad-footer-bottom-inner">
          <p>© {year} <a href="https://acadebility.com">acadebility.com</a> — All Rights Reserved</p>

          <button className="acad-back-to-top" onClick={scrollToTop} aria-label="Back to top">
            <IconArrowUp />
          </button>

          <p>Powered by <a href="https://acadebility.com">acadebility</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;